import axios from '../helpers/axios';

const encode = (value) => encodeURIComponent(String(value || '').trim());

export const getPaymentReceiptId = (receipt) => String(
    receipt?.receiptId || receipt?._id || receipt?.id || ''
).trim();

export const getPaymentReceiptName = (receipt, fallback = 'Чек') => (
    String(receipt?.originalName || receipt?.name || receipt?.filename || '').trim() || fallback
);

export const getPaymentReceiptMimeType = (receipt) => (
    String(receipt?.mimeType || '').trim().toLowerCase()
);

const getFilenameFromDisposition = (headerValue, fallback) => {
    const value = String(headerValue || '');
    const utfMatch = value.match(/filename\*=UTF-8''([^;]+)/i);

    if (utfMatch?.[1]) {
        try {
            return decodeURIComponent(utfMatch[1]);
        } catch (_error) { }
    }

    const plainMatch = value.match(/filename="?([^";]+)"?/i);
    return plainMatch?.[1] || fallback;
};

export const fetchPaymentReceipt = async ({
    paymentAccountId,
    receipt,
    download = false,
} = {}) => {
    const receiptId = getPaymentReceiptId(receipt);

    if (!paymentAccountId || !receiptId) {
        throw new Error('Не найден идентификатор чека');
    }

    const response = await axios.get(
        `/payment-receipts/${encode(paymentAccountId)}/${encode(receiptId)}${download ? '/download' : ''}`,
        { responseType: 'blob' }
    );

    const fallback = getPaymentReceiptName(receipt, `receipt-${receiptId}`);

    return {
        blob: response.data,
        filename: getFilenameFromDisposition(response.headers?.['content-disposition'], fallback),
        mimeType: String(
            response.data?.type ||
            response.headers?.['content-type'] ||
            getPaymentReceiptMimeType(receipt) ||
            'application/octet-stream'
        ).split(';')[0].trim().toLowerCase(),
    };
};

export const downloadPaymentReceiptBlob = ({ blob, filename }) => {
    if (!blob) return false;

    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');

    link.href = url;
    link.download = filename || 'receipt';
    link.style.display = 'none';
    document.body.appendChild(link);
    link.click();
    link.remove();

    window.setTimeout(() => URL.revokeObjectURL(url), 1500);
    return true;
};
